var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCoinbase(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 579 126",
    width: 2500,
    height: 544,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill:#0081c9}")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Imported Layers") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Imported-Layers"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-1",
    className: "st0",
    d: "M37.8 125.9C18.9 125.9.4 112.3.4 81.6c0-30.8 18.5-44.2 37.4-44.2 9.3 0 16.6 2.4 21.8 5.8l-5.7 12.5c-3.5-2.5-8.7-4.1-13.9-4.1-11.4 0-21.8 9-21.8 29.8s10.7 30 21.8 30c5.2 0 10.4-1.6 13.9-4.1l5.7 12.8c-5.4 3.6-12.5 5.8-21.8 5.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-2",
    className: "st0",
    d: "M102.9 125.9c-24.1 0-37.4-19.1-37.4-44.3 0-25.2 13.2-44.2 37.4-44.2 24.1 0 37.4 18.9 37.4 44.2 0 25.2-13.3 44.3-37.4 44.3zm0-74.8c-13.4 0-20 12-20 30.3s6.6 30.4 20 30.4 20-12.1 20-30.4c0-18.3-6.6-30.3-20-30.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-3",
    className: "st0",
    d: "M163.5 23.7c-5.7 0-10.3-4.4-10.3-9.8s4.6-9.8 10.3-9.8c5.7 0 10.3 4.4 10.3 9.8s-4.7 9.8-10.3 9.8zm-8.7 15.4h17.4v85h-17.4v-85z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-4",
    className: "st0",
    d: "M240.4 124.1V67.4c0-9.9-6-16.1-17.8-16.1-6.3 0-12.1 1.1-15.6 2.5v70.4h-17.2V43.4c8.5-3.5 19.4-6 32.7-6 23.8 0 35.3 10.4 35.3 28.4v58.4h-17.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-5",
    className: "st0",
    d: "M303.5 125.9c-11 0-21.9-2.7-28.6-6V.3h17.2v41c4.1-1.9 10.7-3.5 16.6-3.5 21.9 0 36.8 15.8 36.8 41.8 0 32.1-16.6 46.3-42 46.3zm2.2-74.6c-4.7 0-10.3 1.1-13.6 2.8v55.8c2.5 1.1 7.4 2.2 12.3 2.2 13.7 0 23.8-9.5 23.8-31.2.1-18.6-8.7-29.6-22.5-29.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-6",
    className: "st0",
    d: "M392.3 125.9c-24.4 0-36.8-9.9-36.8-26.7 0-23.7 25.2-27.9 50.9-29.3v-5.4c0-10.7-7.1-14.5-18-14.5-8 0-17.8 2.5-23.5 5.2l-4.4-11.8c6.8-3 18.3-6 29.7-6 20.3 0 32.7 7.9 32.7 28.9v53.6c-6.1 3.3-18.6 6-30.6 6zm14.2-44.5c-17.4.9-34.7 2.4-34.7 17.5 0 9 6.9 14.5 20 14.5 5.5 0 12-.9 14.7-2.2V81.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-7",
    className: "st0",
    d: "M461.7 125.9c-9.9 0-20.3-2.7-26.5-6l5.8-13.2c4.4 2.7 13.7 5.5 20.2 5.5 9.3 0 15.5-4.6 15.5-11.7 0-7.7-6.5-10.7-15.1-13.9-11.4-4.3-24.1-9.5-24.1-25.4 0-14 10.9-23.8 29.8-23.8 10.3 0 18.8 2.5 24.8 6l-5.4 12c-3.8-2.4-11.4-5-17.5-5-9 0-14 4.7-14 10.9 0 7.7 6.3 10.4 14.7 13.6 11.8 4.4 24.9 9.3 24.9 25.9-.1 15.1-11.8 25.1-33.1 25.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-8",
    className: "st0",
    d: "M578.6 81.2l-56.5 7.9c1.7 15.3 11.7 23 26 23 8.5 0 17.7-2.1 23.5-5.2l5 12.9c-6.6 3.5-18 6-29.7 6-26.8 0-41.8-17.2-41.8-44.3 0-26 14.5-44.2 38.3-44.2 22.1 0 35.2 14.5 35.2 37.4.2 2.1.2 4.3 0 6.5zM543.3 50c-13.2 0-21.9 10.1-22.2 27.8l41.2-5.7c-.2-14.8-7.7-22.1-19-22.1z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinbase);
export default __webpack_public_path__ + "static/media/coinbase.ac0c4ee59a06da6c04fc3a01d1043bb4.svg";
export { ForwardRef as ReactComponent };